import React, {FC} from 'react';
import {Iso} from '@mui/icons-material';
import {PregnancyListJson} from "../../../api/generated/medical-rest";
import {
    formatDays,
    getEstimatedPregnancyDurationDays,
    getPregnancyDurationDays,
    getPregnancyRemainingDays,
    getPregnancyState,
    PregnancyState
} from "./pregnancy-utils";

type Props = { pregnancy: PregnancyListJson };

const EndDate = ({pregnancy}: Props) => pregnancy.actualEndDate
    ? pregnancy.actualEndDate.toLocaleString()
    : <><Iso sx={{verticalAlign: "bottom"}}/>{pregnancy.calculatedEndDate.toLocaleString()}</>;

const remainingDays = (pregnancy: PregnancyListJson) => {
    const remaining = getPregnancyRemainingDays(pregnancy);
    const pregnancyState = getPregnancyState(pregnancy);
    switch (pregnancyState) {
        case PregnancyState.PREGNANT:
            return remaining >= 0
                ? `${formatDays(remaining)} verbleibend`
                : `${formatDays(-remaining)} überfällig`;
        case PregnancyState.COMPLETED:
            return remaining >= 0
                ? `${formatDays(remaining)} zu früh`
                : `${formatDays(-remaining)} zu spät`;
        default: return null;
    }
};

const PregnancyDateRange: FC<Props> = ({pregnancy}) => {
    const duration = getPregnancyDurationDays(pregnancy);
    const estimatedDuration = getEstimatedPregnancyDurationDays(pregnancy);
    const remaining = remainingDays(pregnancy);
    return (
        <span>
            {pregnancy.startDate.toLocaleString()} - <EndDate pregnancy={pregnancy}/> ({duration}/{estimatedDuration} Tage{!!remaining && ', ' + remaining})
        </span>
    );
}

export default PregnancyDateRange;